import React from 'react';
import Button from '@/components/ui/Button';
import { MessageSquare, Users, Calendar, CheckCircle } from 'lucide-react';

const CollabApp = () => {
  const features = [
    {
      icon: <MessageSquare className="text-orcsys-500" size={20} />,
      text: "Communication transparente en temps réel"
    },
    {
      icon: <Users className="text-orcsys-500" size={20} />,
      text: "Collaboration simplifiée avec votre équipe"
    },
    {
      icon: <Calendar className="text-orcsys-500" size={20} />,
      text: "Suivi des échéances et des jalons du projet"
    },
    {
      icon: <CheckCircle className="text-orcsys-500" size={20} />,
      text: "Validation simplifiée des livrables"
    }
  ];

  return (
    <section id="collab" className="py-20 md:py-28 overflow-hidden">
      <div className="container px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="order-2 lg:order-1 animate-fade-in-left">
            <h2 className="mt-4 text-3xl md:text-4xl font-bold">
              Découvrez <span className="text-orcsys-500">Collab</span>
            </h2>
            <p className="mt-4 text-lg text-gray-600">
              Notre application propriétaire qui simplifie la communication et
              la collaboration entre notre équipe et nos clients pendant tout le cycle de développement.
            </p>

            <div className="mt-8 space-y-4">
              {features.map((feature, index) => (
                <div key={index} className="flex items-start gap-3">
                  <div className="mt-0.5">{feature.icon}</div>
                  <p>{feature.text}</p>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <Button.Link href="/collab">
                En savoir plus sur Collab
              </Button.Link>
            </div>
          </div>

          <div className="order-1 lg:order-2 animate-fade-in-right">
            <div className="relative">
              {/* Laptop Mockup */}
              <div className="relative mx-auto w-full max-w-[600px] md:max-w-[800px]">
                <div className="absolute inset-0 bg-gradient-to-r from-orcsys-100 to-orcsys-200 rounded-xl blur-xl opacity-50 animate-pulse-soft"></div>
                <div className="relative bg-white rounded-xl shadow-xl overflow-hidden border border-gray-100">
                  {/* Laptop Screen */}
                  <div className="aspect-[16/11] bg-gradient-to-br from-orcsys-50 to-white">
                    <img src="/images/collab-app-laptop.png" alt="Collab App" className="w-full h-full object-cover" />
                  </div>
                  {/* Laptop Base */}
                  <div className="h-3 md:h-4 bg-slate-100 border-t border-gray-200"></div>
                </div>
              </div>

              {/* Phone Mockup */}
              <div className="absolute -bottom-4 -right-4 md:-right-8 w-32 h-64 md:w-48 md:h-96">
                <div className="relative">
                  <div className="absolute inset-0 bg-gradient-to-r from-orcsys-100 to-orcsys-200 rounded-xl blur-xl opacity-50 animate-pulse-soft"></div>
                  <div className="relative bg-white rounded-[1.5rem] md:rounded-[2rem] shadow-xl overflow-hidden border border-gray-100">
                    {/* Phone Notch */}
                    <div className="h-4 md:h-6 bg-slate-900 rounded-t-[1.5rem] md:rounded-t-[2rem] flex items-center justify-center">
                      <div className="w-16 md:w-20 h-3 md:h-4 bg-slate-800 rounded-full"></div>
                    </div>
                    {/* Phone Screen */}
                    <div className="aspect-[9/16] bg-gradient-to-br from-orcsys-50 to-white">
                      <div className="bg-gradient-to-br from-orcsys-50 to-white">
                        <img src="/images/collab-app-mobile.jpg" alt="Collab App" className="w-full h-full object-cover" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CollabApp;
